<template>
  <div class="module_scheme_thumb" :title="url ? '' : 'В схеме нет модулей'">
    <img v-if="url && !failed" :src="url" alt="" loading="lazy" @error="failed = true" />
    <span v-else class="module_scheme_thumb__empty">—</span>
  </div>
</template>

<script>
/**
 * Миниатюра модульной схемы в списке: готовая картинка с бэка (поле _thumbnail_url схемы). Бэк собирает
 * SVG при первом запросе, кэширует и пересобирает при изменении схемы или узлов в ней.
 *
 * Адрес в _thumbnail_url стабильный (годится для ссылок и SEO), ответ по нему браузер сверяет с бэком по
 * ETag. В интерфейсе добавляем ?v=<updated_at схемы, unix>: когда схема или узел в ней изменились,
 * адрес меняется и <img> перезагружается сразу (иначе браузер в рамках страницы может показать старую
 * картинку), а пока схема не менялась — бэк отдаёт её с вечным кэшем.
 */
export default {
  name: "ModuleSchemeThumb",
  props: {
    // _thumbnail_url схемы; null — в схеме нет модулей
    src: { type: String, default: null },
    // updated_at схемы (ISO из ответа списка) — версия картинки
    version: { type: String, default: null },
  },
  data: () => ({ failed: false }),
  computed: {
    url() {
      if (!this.src) return null;
      const ts = this.version ? Math.floor(Date.parse(this.version) / 1000) : NaN;
      if (Number.isNaN(ts)) return this.src;
      return `${this.src}${this.src.includes("?") ? "&" : "?"}v=${ts}`;
    },
  },
  watch: {
    url() {
      this.failed = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.module_scheme_thumb {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 208px;
  height: 208px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  &__empty {
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
